module.exports = __webpack_public_path__ + "static/media/banner-right-04.f9417a3f.gif";